import { Injectable } from '@angular/core';
import {
  AddSqaContent,
  Error,
  ResponseAddSqa
} from '@com-delta-idp/mnx-login-ui';
import { BehaviorSubject } from 'rxjs';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { ERROR_CODES, HOME_PAGE_URL } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';
@Injectable({
  providedIn: 'root'
})
export class AddSqaFacadeHelperService {
  addSqaContent$: BehaviorSubject<AddSqaContent | null> =
    new BehaviorSubject<AddSqaContent | null>(null);

  addSqaError$ = new BehaviorSubject<boolean>(false);

  constructor(protected loginHelperUtils: LoginHelperUtils) {}

  getAddSqaContent(): AddSqaContent {
    return this.addSqaContent$.value || ({} as AddSqaContent);
  }

  handleResponseAddSqa(responseAddSqa: ResponseAddSqa): void {
    let navigateUrl: string = HOME_PAGE_URL;
    if (responseAddSqa?.refreshURL && responseAddSqa.refreshURL !== '') {
      navigateUrl = responseAddSqa.refreshURL;
    }
    window.location.href = navigateUrl;
  }

  getRefreshURL(refreshURL: string): string {
    return refreshURL !== '' && refreshURL !== 'null'
      ? refreshURL
      : HOME_PAGE_URL;
  }

  handleError(errors: Error[], aemContent: LoginModalContent): void {
    const errorId: string = errors[0]?.code;
    if (errorId) {
      const bffErrorMessage: string =
        this.loginHelperUtils.getErrorMessageFromAem(
          aemContent,
          `ERROR_MSG_${errorId}`,
          errorId
        );
      if (bffErrorMessage) {
        this.getAddSqaContent().errorMessage = bffErrorMessage;
        this.displayOverylayMessage(true);
        return;
      }
    }
    this.handleDefaultError(aemContent);
  }

  handleDefaultError(aemContent: LoginModalContent): void {
    const bffErrorMessage: string =
      this.loginHelperUtils.getErrorMessageFromAem(
        aemContent,
        `ERROR_MSG_${ERROR_CODES.ERROR_CODE_21}`
      );
    this.getAddSqaContent().errorMessage = bffErrorMessage;
    this.displayOverylayMessage(true);
  }

  displayOverylayMessage(value: boolean): void {
    this.getAddSqaContent().hasError = value;
  }
}
